import { Divider, Flex, PaperSection, SectionTitle, Text } from '@shared/components';

import AdminExamRoomDetails from '../../components/admin-exam-room-details/admin-exam-room-details';
import { useAdminExamRoomRequestInfo } from '../../providers';

const LOCATION_DETAILS = [
  {
    label: 'จังหวัด',
    value: [['room', 'location', 'province']],
  },
  {
    label: 'สถานที่/หน่วยงาน (ภาษาไทย)',
    value: [['room', 'location', 'nameTh']],
  },
  {
    label: 'สถานที่/หน่วยงาน (ภาษาอังกฤษ)',
    value: [['room', 'location', 'nameEn']],
  },
  {
    label: 'อาคาร',
    value: [['room', 'location', 'building']],
  },
];

const ROOM_INFORMATION = [
  {
    label: 'ชั้น',
    value: [['room', 'floor']],
  },
  {
    label: 'ชื่อห้อง',
    value: [['room', 'name']],
  },
  {
    label: 'เลขห้อง',
    value: [['room', 'roomNumber']],
  },
  {
    label: 'จำนวนที่นั่ง',
    value: [['room', 'seatCount']],
  },
];

const getNestedValue = (obj: Record<string, unknown>, path: string | string[]): unknown => {
  const pathArray = Array.isArray(path) ? path : [path];
  return pathArray.reduce((current: unknown, key: string) => {
    return (current as Record<string, unknown>)?.[key];
  }, obj);
};

export default function AdminExamLocationManagementRoomRequest({
  roomRequestId,
}: {
  roomRequestId: string;
}) {
  const { examRoomRequestInfo } = useAdminExamRoomRequestInfo();

  const roomRequestData = {
    room: {
      name: examRoomRequestInfo.name,
      building:
        examRoomRequestInfo.examLocationRequestInfo.buildingName ??
        examRoomRequestInfo.examLocationRequestInfo.building?.nameTh ??
        '-',
      floor: examRoomRequestInfo.floor,
      roomNumber: examRoomRequestInfo.roomNumber || '-',
      seatCount: examRoomRequestInfo.seatCount,
      location: {
        province: examRoomRequestInfo.examLocationRequestInfo.province.nameTh,
        nameTh: examRoomRequestInfo.examLocationRequestInfo.nameTh,
        nameEn: examRoomRequestInfo.examLocationRequestInfo.nameEn || '-',
        building:
          examRoomRequestInfo.examLocationRequestInfo.building?.nameTh ??
          examRoomRequestInfo.examLocationRequestInfo.buildingName ??
          '-',
      },
    },
  };

  return (
    <>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(6),
        })}
      >
        <PaperSection title='ข้อมูลสถานที่สอบ'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(6),
              p: theme.spacing(6),
            })}
          >
            <SectionTitle title='Location Details' />

            {LOCATION_DETAILS.map((detail) => (
              <Flex
                key={detail.label}
                sx={(theme) => ({
                  gap: theme.spacing(6),
                })}
              >
                <Text
                  variant='body1Semibold'
                  sx={{
                    maxWidth: '240px',
                    width: '50%',
                  }}
                >
                  {detail.label}
                </Text>

                <Flex
                  sx={(theme) => ({
                    flexDirection: 'column',
                    gap: theme.spacing(4),
                  })}
                >
                  {detail.value.map((accessor, index) => (
                    <Text key={index}>
                      {String(getNestedValue(roomRequestData, accessor) || '')}
                    </Text>
                  ))}
                </Flex>
              </Flex>
            ))}
          </Flex>
        </PaperSection>

        <PaperSection title='ข้อมูลห้องสอบ'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(6),
              p: theme.spacing(6),
            })}
          >
            <SectionTitle title='Room Information' />

            {ROOM_INFORMATION.map((information) => (
              <Flex
                key={information.label}
                sx={(theme) => ({
                  gap: theme.spacing(6),
                })}
              >
                <Text
                  variant='body1Semibold'
                  sx={{
                    maxWidth: '240px',
                    width: '50%',
                  }}
                >
                  {information.label}
                </Text>
                <Flex
                  sx={(theme) => ({
                    flexDirection: 'column',
                    gap: theme.spacing(4),
                  })}
                >
                  {information.value.map((accessor, index) => (
                    <Text key={index}>
                      {String(getNestedValue(roomRequestData, accessor) || '')}
                    </Text>
                  ))}
                </Flex>
              </Flex>
            ))}

            <Divider />

            <SectionTitle title='Room Details' />

            <AdminExamRoomDetails
              examRoomDetailType='physical-info'
              examRoomRequestId={roomRequestId}
            />
            <AdminExamRoomDetails
              examRoomDetailType='computer-info'
              examRoomRequestId={roomRequestId}
            />
          </Flex>
        </PaperSection>
      </Flex>
    </>
  );
}
